// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2c1_B","info":"Note_info__3Bizq","note":"Note_note__3I62i","actions":"Note_actions__2YkBd"};